import { styled } from "@mui/material/styles";
import { Stack, TableContainer } from "@mui/material";

export const StyledSubStack = styled(Stack)(({ theme }) => ({
  padding: "15px",
  backgroundColor: theme.palette.hubColors.greyLightest,
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: "8px",
  border: `1px solid ${theme.palette.hubColors.greyLight}`,
  overflow: "auto",
  "& .MuiTable-root": {
    borderCollapse: "separate",
    borderSpacing: 0,
  },
  "& .MuiTableHead-root": {
    backgroundColor: theme.palette.hubColors.greyLightest,

    "& .MuiTableRow-root": {
      "& .MuiTableCell-root": {
        borderBottom: `1px solid ${theme.palette.hubColors.greyLight}`,
        padding: "8px 12px",
        fontSize: 11,
        fontWeight: 600,
        color: theme.palette.hubColors.greyShade,
        textTransform: "uppercase",
        letterSpacing: "0.03em",
        whiteSpace: "nowrap",
        lineHeight: 1.2,
      },
    },
  },
  "& .MuiTableBody-root": {
    "& .MuiTableRow-root": {
      transition: "background-color 0.15s ease",

      "&:hover": {
        backgroundColor: theme.palette.hubColors.greyLightest,
      },

      ".MuiTableCell-root": {
        borderBottom: "none",
      },

      "& .MuiTableCell-root": {
        borderBottom: `1px solid ${theme.palette.hubColors.greyLight}`,
        padding: "8px 10px",
        fontSize: 12,
        lineHeight: 1.4,
        "&[variant='blueBold']": {
          color: theme.palette.hubColors.mainFocus,
          fontWeight: 500,
          cursor: "pointer",
          "&:hover": {
            textDecoration: "underline",
          },
        },
      },
    },
  },
}));
